/**
 * Recursively `Object.freeze` plain data (objects and arrays) and return it with the same type.
 *
 * Every tuning group, character table and enum table in @hf/shared is deep-frozen at module load: a stray write
 * (e.g. a debug slider poking `MOVE.runSpeed`) throws in strict mode instead of silently desyncing one peer.
 * A live tuning panel must be OFFLINE-ONLY and edit a structured copy, never these objects.
 */
export const deepFreeze = <T>(value: T): T => {
  if (value !== null && typeof value === 'object' && !Object.isFrozen(value)) {
    Object.freeze(value);
    for (const k of Object.keys(value)) deepFreeze((value as Record<string, unknown>)[k]);
  }
  return value;
};
